import gql from 'graphql-tag';
import { graphql } from '@apollo/react-hoc';
import VisitsAvailability from './visits-availability';
import { SimpleLoadingComponent } from '../../utils/apollo';

const query = gql`
  query VisitsAvailability(
    $id: String!, $numSchoolsWithinProximity: Int!, $distance: String, $fromDate: OrdinalDate!, $toDate: OrdinalDate!, $nextDate: String!
  ) {
    viewer {
      id
      institution {
        id
        field_he_control
      }
      repVisitHighSchoolsWithinProximity(id: $id, numSchoolsWithinProximity: $numSchoolsWithinProximity, distance: $distance) {
        distance {
          text
        }
        toSchool {
          id
          name
          interestedStudents
          general {
            field_hs_na_nces_id
          }
          naviance {
            field_hs_na_nguid
            field_hs_elna_phone
          }
          address {
            field_hs_elna_address_line1
            field_hs_elna_state_latest
            field_hs_elna_city
            field_hs_na_country_name
          }
          repVisitsAvailability(fromDate: $fromDate, toDate: $toDate) {
            id
            date
            timezone
            status
            appointments {
              id
              startTime
              startISOTime
              endISOTime
              status
              visitLocationType
            }
          }
          repVisitsAccount {
            id
            supportsRepVisits
            availabilityVisible
            firstVisitDay
            lastVisitDay
            webInstructions
            allowForProfit
            primaryContact {
              id
              field_first_name
              field_last_name
              mail
            }
            availabilitySettings {
              rsvpDeadline
            }
          }
          repVisitsNextAppointmentDate(fromDate: $nextDate) {
            date
          }
        }
      }
    }
  }
`;

const graphqlData = graphql(query, {
  options: ({ id, numSchoolsWithinProximity, distance, fromDate, toDate }) => ({
    variables: {
      id,
      numSchoolsWithinProximity,
      distance,
      fromDate,
      toDate,
      nextDate: toDate,
    },
    fetchPolicy: 'cache-and-network',
  }),
});

export default SimpleLoadingComponent(graphqlData)(VisitsAvailability);
